//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from 'axios'
import { date } from 'quasar'
export default {
  data () {
    const timeStamp = Date.now()
    const formattedString = date.formatDate(timeStamp, 'YYYY/MM/DD')
    return {
      visible: false,
      progress1: 0.3,
      progressLabel1: '50%',
      data_hourly_arr: [],
      datex: '2019/02/01',
      model: null,
      time_line_data: [],
      department_arr: [],
      department_val: '',
      date_val: formattedString,
      location: 'ALL',
      sum_pcs: 0,
      sum_per: 0,
      locations: ['G1', 'G2', 'G3', 'G4', 'TRM', 'VN', 'INDO'],
      locations_val: 'G1'
    }
  },
  watch: {
    locations_val: function (val) {
      this.LoadDepartment()
    },
    department_val: function (val) {
      this.LoadDataAll()
    },
    date_val: function (val) {
      this.LoadDataAll()
    }
  },
  created () {
    this.pullData()
  },
  mounted () {
    this.LoadDepartment()
  },
  methods: {
    pullData () {
      this.pulling = setInterval(() => {
        // this.LoadDataAll()
      }, 5000)
    },
    avg_r_per (x) {
      let sum = 0
      if (x === '5') {
        this.data_hourly_arr.forEach(e => {
          sum = sum + (this.math_mod(e['QTY_' + x], e.P100) + this.math_mod(e['QTY_' + (parseFloat(x) + 1)], e.P100))
        })
      } else {
        this.data_hourly_arr.forEach(e => {
          sum = sum + this.math_mod(e['QTY_' + x], e.P100)
        })
      }
      let maxNumber =
          parseFloat(sum) / (parseFloat(this.data_hourly_arr.length) - 1)
      if (!isFinite(maxNumber)) {
        maxNumber = 0
        // expected output: 'Let's call it Infinity!'
      }

      return maxNumber
    },
    avg_r_qty (x) {
      let sum = 0
      if (x === '5') {
        this.data_hourly_arr.forEach(e => {
          sum = sum + (parseFloat(e['QTY_' + x]) + parseFloat(e['QTY_' + (parseFloat(x) + 1)]))
        })
      } else {
        this.data_hourly_arr.forEach(e => {
          sum = sum + parseFloat(e['QTY_' + x])
        })
      }
      let maxNumber =
          parseFloat(sum) / (parseFloat(this.data_hourly_arr.length) - 1)
      if (!isFinite(maxNumber)) {
        maxNumber = 0
        // expected output: 'Let's call it Infinity!'
      }

      return maxNumber
    },
    avg_c_per (index) {
      let arr = []
      let sum = 0
      for (let num = 0; num < 14; num++) {
        arr[num] = this.math_mod(
          this.data_hourly_arr[index]['QTY_' + (num + 1)],
          this.data_hourly_arr[index]['P100']
        )
        sum = sum + parseFloat(arr[num])
      }

      let maxNumber = (sum / 13).toFixed(2)
      if (!isFinite(maxNumber)) {
        maxNumber = 0
        // expected output: 'Let's call it Infinity!'
      }

      return maxNumber
    },
    avg_c_qty (index) {
      let arr = []
      let sum = 0
      for (let num = 0; num < 14; num++) {
        arr[num] = this.data_hourly_arr[index]['QTY_' + (num + 1)]
        sum = sum + parseFloat(arr[num])
      }
      return sum
    },
    per_v_avg_c_qty (val, total) {
      let res = 0
      if (isFinite((val / total) * 100)) {
        res = (val / total) * 100
      }
      return parseFloat(res) / 100
    },
    avg_f (index) {
      let arr = []
      for (let num = 0; num < 14; num++) {
        arr[num] = this.math_mod(
          this.data_hourly_arr[index]['QTY_1'],
          this.data_hourly_arr[index]['P100']
        )
      }
      console.log(arr)
      return 0.7
    },
    math_mod (pcs, per) {
      let num = parseFloat(pcs) / parseFloat(per)
      if (!isFinite(num)) {
        num = 0
      }
      return parseFloat(num * 100).toFixed(2)
    },
    getMax (arr, prop) {
      if (arr.length === 0) {
        return 0
      }
      var max
      for (var i = 0; i < arr.length; i++) {
        if (max == null || parseInt(arr[i][prop]) > parseInt(max[prop])) {
          max = arr[i]
        }
      }
      return max
    },
    date_select () {
      this.$refs.qDateProxy.hide()
      this.LoadDataAll()
    },
    async LoadDataAll () {
      try {
        this.visible = true
        this.sum_pcs = 0
        const params = new FormData()
        let year = this.date_val.slice(0, 4)
        let month = this.date_val.slice(5, 7)
        let day = this.date_val.slice(8, 10)
        let changFormat = day + '/' + month + '/' + year
        let dataVal = ''
        let org = this.locations_val
        dataVal = this.locations_val
        if (this.locations_val === 'TRM') {
          dataVal = 'TRM'
          org = 'G5'
        } else if (this.locations_val === 'VN') {
          dataVal = 'VN'
          org = 'VN2'
        } else if (this.locations_val === 'INDO') {
          dataVal = 'INDO'
        } else {
          dataVal = 'NYG'
        }
        params.append('Local', dataVal)
        params.append('org', org)
        params.append('dep', this.department_val)
        params.append('date', changFormat)
        void axios({
          method: 'post',
          url: this.$api + 'Hourly_output.php/Load_Hourly_output',
          // url: 'http://localhost/nygcontrolroom/api/Hourly_output.php/Load_Hourly_output',
          data: params
        })
          .then(res => {
            console.log(res.data)
            var dataInFunction = []
            this.data_hourly_arr = []
            this.time_line_data = []
            if (res.data.dt_sql !== undefined && res.data.dt_oic !== undefined) {
              res.data.dt_sql.forEach(m => {
                res.data.dt_oic.forEach(o => {
                  if (
                    m.location_code === o.BU &&
                        parseInt(m.line_name) === parseInt(o.MC_LINE) &&
                        parseInt(m.period_sort) === parseInt(o.HOURLY) &&
                        m.so_no === o.SO_NO &&
                        m.so_year === o.SO_YEAR
                  ) {
                    dataInFunction.push({
                      BU: o.BU,
                      MC_LINE: o.MC_LINE,
                      SO_YEAR: o.SO_YEAR,
                      SO_NO: o.SO_NO,
                      HOURLY: m.period_sort,
                      QTY: o.QTY,
                      START_TIME: m.s_time,
                      END_TIME: m.e_time,
                      QA: m.qa_target,
                      WORKER: m.worker,
                      SMV: m.smv,
                      CUSTOMER: m.customer_name,
                      PRODUCT_CATAGORY: m.product_category
                    })
                  }
                })
              })
              this.time_line_data = res.data.dt_sql_time
            }
            console.log(dataInFunction)

            function groupBy (array, f) {
              var groups = {}
              array.forEach(function (o) {
                var group = JSON.stringify(f(o))
                groups[group] = groups[group] || []
                groups[group].push(o)
              })
              return Object.keys(groups).map(function (group) {
                return groups[group]
              })
            }

            var resultXXX = groupBy(dataInFunction, function (item) {
              return [item.MC_LINE, item.SO_NO]
            })

            let filterDataSoLine = []
            let num = 0
            resultXXX.forEach(e => {
              filterDataSoLine[num] = e[0]
              num++
            })
            console.log(filterDataSoLine)
            for (let num = 0; num < filterDataSoLine.length; num++) {
              const result = dataInFunction.filter(
                word =>
                  word.MC_LINE === filterDataSoLine[num]['MC_LINE'] &&
                  word.SO_NO === filterDataSoLine[num]['SO_NO']
              )
              const sumAll = result
                .map(item => item.QA)
                .reduce((prev, curr) => parseInt(prev) + parseInt(curr), 0)
              this.data_hourly_arr.push({
                SUM_PCR: sumAll,
                LINE: result[0].MC_LINE,
                CUSTOMER: result[0].CUSTOMER,
                TYPE: result[0].PRODUCT_CATAGORY,
                SO: result[0].SO_NO,
                SMV: result[0].SMV,
                MAN: result[0].WORKER,
                P100: result[0].QA,
                QTY_1: 0,
                QTY_2: 0,
                QTY_3: 0,
                QTY_4: 0,
                QTY_5: 0,
                QTY_6: 0,
                QTY_7: 0,
                QTY_8: 0,
                QTY_9: 0,
                QTY_10: 0,
                QTY_11: 0,
                QTY_12: 0,
                QTY_13: 0,
                QTY_14: 0
              })
            }
            console.log(this.data_hourly_arr)
            this.data_hourly_arr.forEach(ex => {
              let result = dataInFunction.filter(
                // eslint-disable-next-line eqeqeq
                word => parseInt(word.SO_NO) == ex.SO
              )
              result.forEach(e => {
                ex['QTY_' + e.HOURLY] = e.QTY
              })
            })

            this.time_line_data.forEach(x => {
              this.data_hourly_arr.forEach(e => {
                this.sum_pcs = this.sum_pcs + parseInt(e['QTY_' + x.period_sort])
              })
            })
            this.visible = false
          })
      } catch (err) {
        this.$q.notify({
          position: 'top-right',
          timeout: 2500,
          textColor: 'white',
          color: 'red',
          message: err,
          html: true
        })
        this.visible = false
      }
      /* let url = this.$api + 'Hourly_output.php/Load_Hourly_output'
        const res = await axios.post(url, params).then(value => {
            console.log(value)
            setTimeout(() => {
                return value
            }, 3000)
        })
*/
    },
    LoadDepartment () {
      try {
        const params = new FormData()
        let dataVal = ''
        let org = this.locations_val
        dataVal = this.locations_val
        if (this.locations_val === 'TRM') {
          dataVal = 'TRM'
          org = 'G5'
        } else if (this.locations_val === 'VN') {
          dataVal = 'VN'
          org = 'VN2'
        } else if (this.locations_val === 'INDO') {
          dataVal = 'INDO'
        } else {
          dataVal = 'NYG'
        }
        params.append('org', org)
        params.append('Local', dataVal)
        void axios({
          method: 'post',
          url: this.$api + 'Hourly_output.php/LoadDepartment',
          // url: 'http://localhost/nygcontrolroom/api/Hourly_output.php/LoadDepartment',
          data: params
        })
          .then(res => {
            console.log(res.data)
            this.department_arr = []
            let index = 0
            this.department_arr[index] = 'ALL'
            index++
            if (res.data.dt_sql.length > 0) {
              res.data.dt_sql.forEach(e => {
                this.department_arr[index] = e.DEPARTMENT
                index++
              })
            }

            this.department_val = this.department_arr[0]
            this.LoadDataAll()
          })
      } catch (err) {
        this.$q.notify({
          position: 'top-right',
          timeout: 2500,
          textColor: 'white',
          color: 'red',
          message: err,
          html: true
        })
      }
    }
  }
}
